var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 384 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsBx: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#",
    d: "M 384 24 L 384 72 C 384 85.2 373.2 96 360 96 L 24 96 C 10.8 96 0 85.2 0 72 L 0 24 C 0 10.8 10.8 0 24 0 L 360 0 C 373.2 0 384 10.8 384 24 Z M 32 128 L 352 128 L 352 322.486 C 346.709 319.248 341.145 316.452 335.385 314.127 C 320.464 308.103 304.225 305.236 288 306.003 L 288 296 C 288 291.6 284.4 288 280 288 L 224 288 L 224 232 C 224 227.6 220.4 224 216 224 L 168 224 C 163.6 224 160 227.6 160 232 L 160 288 L 104 288 C 99.6 288 96 291.6 96 296 L 96 344 C 96 348.4 99.6 352 104 352 L 160 352 L 160 408 C 160 412.4 163.6 416 168 416 L 185.635 416 C 185.641 415.951 185.646 415.902 185.652 415.853 C 186.376 415.851 187.09 415.837 187.779 415.822 C 187.751 415.883 187.725 415.942 187.698 416 L 188.136 416 C 189.691 442.898 201.472 466.806 219.506 484.417 C 233.016 497.609 250.032 507.267 268.886 512 L 64 512 C 46.4 512 32 497.6 32 480 Z M 185.584 415.974 L 185.592 415.854 C 185.602 415.854 185.613 415.854 185.624 415.853 Z M 339.266 512 C 339.266 512.138 339.265 512.275 339.265 512.41 C 339.021 512.411 338.777 512.412 338.533 512.412 C 338.539 512.276 338.544 512.138 338.549 512 L 338.045 512 C 338.045 512.045 338.045 512.089 338.046 512.133 C 337.876 512.196 337.706 512.252 337.535 512.302 C 337.538 512.191 337.542 512.082 337.546 511.976 C 337.859 511.986 338.193 511.992 338.549 511.996 C 338.557 511.777 338.566 511.556 338.574 511.333 C 338.739 511.336 338.904 511.339 339.069 511.343 C 339.133 511.52 339.198 511.714 339.266 511.923 C 339.266 511.949 339.266 511.974 339.266 512 Z M 338.046 512.208 C 338.046 512.277 338.047 512.346 338.047 512.414 C 337.917 512.414 337.786 512.414 337.656 512.415 C 337.787 512.35 337.917 512.281 338.046 512.208 Z M 340.506 512 C 341.061 511.766 341.57 511.579 342.037 511.435 C 343.369 511.488 344.701 511.553 346.019 511.619 C 346.23 511.835 346.364 512.099 346.431 512.392 C 344.098 512.398 341.764 512.404 339.428 512.41 C 339.382 512.277 339.336 512.14 339.291 512 C 339.283 511.974 339.274 511.948 339.266 511.923 C 339.266 511.728 339.267 511.537 339.267 511.347 C 339.956 511.363 340.646 511.384 341.338 511.409 C 341.107 511.59 340.831 511.787 340.506 512 Z M 322.175 511.926 C 321.317 512.145 320.463 512.322 319.614 512.464 C 314.599 512.477 309.585 512.489 304.574 512.498 C 301.669 512.263 298.696 512.022 295.594 512 L 320 512 C 320.731 512 321.456 511.975 322.175 511.926 Z M 295.594 512 L 294.812 512 C 295.073 511.998 295.334 511.998 295.594 512 Z M 294.812 512 C 286.192 512.059 276.914 514.016 268.886 512 Z M 338.384 512 C 338.272 512.073 338.16 512.142 338.046 512.208 C 338.046 512.183 338.046 512.158 338.046 512.133 C 338.159 512.092 338.272 512.047 338.384 512 Z M 322.175 511.926 C 323.42 511.609 324.709 511.563 326.017 511.65 C 326.018 511.809 326.018 511.967 326.018 512.125 C 324.726 511.945 323.436 511.84 322.175 511.926 Z M 337.535 512.302 C 337.534 512.339 337.532 512.377 337.531 512.415 C 337.388 512.415 337.245 512.416 337.102 512.416 C 337.247 512.382 337.392 512.344 337.535 512.302 Z M 326.472 512.192 C 327.017 512.076 327.574 511.974 328.143 511.885 C 329.318 512.053 330.497 512.268 331.662 512.431 C 330.432 512.435 329.202 512.438 327.972 512.442 C 327.473 512.354 326.973 512.268 326.472 512.192 Z M 337.546 511.976 C 335.125 511.903 333.983 511.671 333.679 511.375 C 334.959 511.324 336.265 511.31 337.586 511.321 C 337.569 511.525 337.556 511.744 337.546 511.976 Z M 338.89 502.842 C 339.065 498.566 339.211 496.641 339.256 502.985 C 339.134 502.937 339.012 502.89 338.89 502.842 Z",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(6.152154, 0, 0, 6.548128, 199.544952, 314.994385)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UX-82-Therapy-Status-Isolated",
    transform: "translate(-535.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(531.000000, 641.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    fill: "#"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 6.000000)",
    fill: "#"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(7.180661, 0, 0, 6.489009, 182.851883, 307.364746)",
    style: {},
    bxOrigin: "0.845 0.404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    transform: "translate(-535.000000, -646.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-3",
    transform: "translate(531.000000, 641.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-4",
    transform: "translate(4.000000, 5.000000)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g-5",
    fill: "#"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-6",
    transform: "translate(4.000000, 6.000000)",
    fill: "#"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.585 14.714 C -0.386 9.615 3.815 5.511 8.987 5.511 C 11.996 5.511 14.756 6.879 16.596 9.267 L 14.955 10.908 L 14.93 10.859 C 13.563 8.943 11.349 7.799 8.987 7.799 C 5.109 7.799 1.901 10.859 1.702 14.714 L 2.945 13.471 L 4.561 15.088 L 0.558 19.093 L -3.445 15.088 L -1.829 13.471 L -0.585 14.714 Z",
    id: "Path",
    style: {
      fill: "black"
    },
    transform: "matrix(0, -1.106588, 0.903678, 0, -4.541553, 19.578372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.169 5.105 C 21.971 10.205 17.768 14.31 12.596 14.31 C 9.588 14.31 6.827 12.941 4.987 10.552 L 6.628 8.911 L 6.653 8.961 C 8.021 10.876 10.234 12.02 12.596 12.02 C 16.475 12.02 19.682 8.961 19.881 5.105 L 18.638 6.349 L 17.022 4.732 L 21.025 0.727 L 25.028 4.732 L 23.413 6.349 L 22.169 5.105 Z",
    id: "Path",
    style: {
      fill: "black"
    },
    transform: "matrix(0, -1.106588, 0.903678, 0, 8.213194, 24.125624)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedSync);
export default __webpack_public_path__ + "static/media/med_sync.2f17c82572aab2b9f4cc2c4df9abe29c.svg";
export { ForwardRef as ReactComponent };